import PropTypes from 'prop-types'
import { MoveIcon } from 'components/icons'
import RegItemImage from 'registry/components/reg-item-image'
import CategorySelector from 'shared/reg-item-form/CategorySelector'
import { regItemProps } from './reg-item-props'

const OrganizeRegItemCard = ({
  regItem,
  regItem: { title, imgUrl, id, isGroupGift, isFavorite, categoryId },
  categories,
  onRegItemChange,
  onNewCategoryChange,
}) => (
  <div className="flex justify-start user-select-none">
    <div className="flex center mrl">
      <MoveIcon />
    </div>
    <div className="prl">
      <RegItemImage
        isFavorite={isFavorite}
        isGroupGift={isGroupGift}
        src={imgUrl}
        width={100}
      />
    </div>

    <div className="flex-grow">
      <div className="mbl mtn text-body">{title}</div>
      <div style={{ maxWidth: 320 }}>
        <CategorySelector
          categories={categories}
          label={null}
          name="categoryId"
          value={categoryId}
          onCategoryAdd={onNewCategoryChange}
          onCategoryChange={onRegItemChange}
        />
      </div>
    </div>
  </div>
)

OrganizeRegItemCard.propTypes = {
  regItem: PropTypes.shape(regItemProps),
  isMobile: PropTypes.bool,
}

export default OrganizeRegItemCard
